<template>
  <modal name="modal-address-map" class="modal-address-map" @close="handleModalClose">
    <template v-if="openModal">
      <p slot="header" class="modal-address-map__title">
        {{ $t('Pin your address on the map') }}
      </p>
      <div slot="content">
        <address-map v-if="step === 'map'" @address-selected="selectAddress" :current-address="selectedAddressData" />
        <address-confirmation v-if="step === 'confirmation'" ref="confirmation" @address-updated="updateAddress" :current-address="selectedAddressData" />
        <base-address-autocomplete-input v-show="step !== 'confirmation'" @address-selected="selectAddress" :show-map-modal="false" class="input-field" />
        <div class="map-modal-actions">
          <mini-button-full v-if="step === 'confirmation'" class="address_btn" @click.native="() => { step === 'confirmation' ? handleBackStep() : handleClose() }">
            {{ step === 'confirmation' ? $t('Back') : $t('Close') }}
          </mini-button-full>
          <mini-button-full class="address_btn" @click.native="selectAddressToParent">
            {{ $t('Confirm') }}
          </mini-button-full>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from 'theme/components/core/Modal.vue';

const MiniButtonFull = () => import(/* webpackChunkName: "vsf-mini-button-full" */ 'theme/components/theme/MiniButtonFull.vue');

export default {
  name: 'AddressMapModal',
  components: {
    Modal,
    MiniButtonFull,
    BaseAddressAutocompleteInput: () => import('theme/components/core/blocks/Form/BaseAddressAutocompleteInput.vue'),
    AddressMap: () => import('theme/components/core/blocks/MyAccount/ShippingDetails/AddressMap/AddressMap.vue'),
    AddressConfirmation: () => import('theme/components/core/blocks/MyAccount/ShippingDetails/AddressMap/AddressConfirmation.vue')
  },
  props: {
    openModal: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data: () => ({
    timeout: null,
    selectedAddressData: {},
    step: 'map',
    confirmAddress: false
  }),
  computed: {
    hasHouseNumber () {
      return !!(this.selectedAddressData && this.selectedAddressData.address && this.selectedAddressData.address.house_number);
    }
  },
  methods: {
    selectAddress (address) {
      this.selectedAddressData = address;
    },
    updateAddress (address) {
      if (!this.selectedAddressData || !this.selectedAddressData.address) {
        this.selectedAddressData = {
          address: {
            road: address.street,
            house_number: address.house
          }
        }
        return;
      }
      this.selectedAddressData.address.road = address.street;
      this.selectedAddressData.address.house_number = address.house;
    },
    selectAddressToParent () {
      this.$emit('address-selected', this.selectedAddressData);

      if (!this.hasHouseNumber) {
        if (this.step !== 'confirmation') {
          this.step = 'confirmation';
          return;
        }
        if (!this.$refs.confirmation) {
          return;
        }
        this.$refs.confirmation.$v.$touch()
        if (this.$refs.confirmation.$v.$invalid) {
          return;
        }
      }

      this.confirmAddress = true;
      this.$bus.$emit('modal-toggle', 'modal-address-map');
      this.selectedAddressData = {};
      this.timeout = null;
      this.step = 'map';
      this.confirmAddress = false;
    },
    handleBackStep () {
      this.step = 'map';
      this.$emit('handleCancelAction', null);
    },
    handleClose () {
      this.selectedAddressData = {};
      this.timeout = null;
      this.step = 'map';
      this.$emit('handleCancelAction', null);
      this.$bus.$emit('modal-hide', 'modal-address-map');
    },
    handleModalClose () {
      this.$emit('close');
      if (!this.confirmAddress) {
        this.selectedAddressData = {};
        this.$emit('address-selected', null);
        this.step = 'map';
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .modal-address-map {
    &__title {
      text-align: center;
      font-size: 2rem;
      @media screen and (max-width: 600px) {
        font-size: 1.5rem;
      }
      @media screen and (max-width: 425px) {
        font-size: 1.25rem;
      }
    }
    &__error {
      margin: 0 0 40px;
      font-size: 1.25rem;
      text-align: center;
    }

    & .geolocation-control {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0;
      span {
        font-size: 1rem;
        font-weight: 600;
        margin-right: 10px;
        width: 80%;
      }
      button {
        width: auto;
        flex: auto;
      }
    }

    & .map-modal-actions {
      display: flex;
      column-gap: 5%;
    }
  }
  .input-field {
    margin: 24px -8px -16px;

    &:has(.cl-error) {
      margin: 24px -8px 0;
    }
  }
  .address_btn {
    font-size: 1rem;
    font-weight: 600;
    &.error {
      background-color: orangered;
      &:hover {
        background-color: red;
      }
    }
  }
</style>

<style lang="scss">
  .modal-address-map {
    .modal-header {
      padding: 16px 65px;
      @media screen and (max-width: 600px) {
        padding: 16px 40px;
      }
      @media screen and (max-width: 425px) {
        padding: 40px 20px 16px;
      }
      .modal-close {
        @media screen and (min-width: 425px) {
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .modal-content:not(:has(.shipping-block)) {
      height: 65vh;
      @media screen and (max-width: 600px) {
        height: calc(100vh - 124px);
      }
      @media screen and (max-width: 425px) {
        height: calc(100vh - 142px);
      }
      >div {
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    }
  }
</style>
